import { createRouter, createWebHistory } from 'vue-router';
import i18n, { getAppLocale } from '@/i18n';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'Home', component: () => import('@/views/Home.vue'), meta: { titleKey: 'meta.home' } },
    { path: '/news', name: 'News', component: () => import('@/views/News.vue'), meta: { titleKey: 'meta.news' } },
    {
      path: '/news/:slug',
      name: 'NewsDetail',
      component: () => import('@/views/NewsDetail.vue'),
      meta: { titleKey: 'meta.newsDetail' },
    },
    { path: '/about', name: 'About', component: () => import('@/views/About.vue'), meta: { titleKey: 'meta.about' } },
    { path: '/contact', name: 'Contact', component: () => import('@/views/Contact.vue'), meta: { titleKey: 'meta.contact' } },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
  scrollBehavior: () => ({ top: 0 }),
});

function siteBrand() {
  const locale = getAppLocale();
  if (locale === 'en') {
    return (typeof __APP_TITLE_EN__ !== 'undefined' && __APP_TITLE_EN__) || 'Linky precision';
  }
  return (typeof __APP_TITLE__ !== 'undefined' && __APP_TITLE__) || '东莞市灵琪金塑商贸有限公司';
}

router.afterEach((to) => {
  const { t } = i18n.global;
  const brand = siteBrand();
  // 首页只用公司名，避免刷新时短暂出现「首页 | App」
  if (to.name === 'Home') {
    document.title = brand;
    return;
  }
  const titleKey = (to.meta.titleKey as string) || 'common.siteSuffix';
  document.title = `${t(titleKey)} | ${brand}`;
});

export default router;
